import { getLogger } from '../logging/functions';
export default getLogger('app:sounds');
